var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        persistent: "",
        "content-class": "launcher-dialog",
        width: _vm.modal_width,
        "max-width": _vm.modal_width,
        transition: "dialog-transition"
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _vm.step === "search"
        ? _c(
            "v-card",
            { staticClass: "background darken-1" },
            [
              _c(
                "v-card-title",
                [
                  _c("LauncherHeader", {
                    attrs: { step: _vm.step, jd: _vm.jd_version_selected },
                    on: {
                      "open-old-launcher": function($event) {
                        return _vm.openOldLauncher()
                      },
                      close: function($event) {
                        return _vm.$emit("close")
                      },
                      search: function($event) {
                        _vm.step = "search"
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "JdsMenu",
                    {
                      attrs: {
                        jds: _vm.jds_filtered,
                        loading: _vm.loading_jds,
                        jd_type_selected: _vm.jd_type_selected,
                        jd_selected: _vm.jd_selected,
                        jd_version_selected: _vm.jd_version_selected,
                        versions: _vm.jd_versions
                      },
                      on: {
                        change: function($event) {
                          return _vm.onJdSelected($event)
                        },
                        "version-selected": function($event) {
                          _vm.jd_version_selected = $event
                        }
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "jd-append" },
                        [
                          _c("TypesMenu", {
                            attrs: {
                              jds_types: _vm.jds_types,
                              loading: _vm.loading_jds,
                              jd_type_selected: _vm.jd_type_selected
                            },
                            on: {
                              change: function($event) {
                                return _vm.onTypeSelect($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("FrequentJds", {
                            attrs: { jds: _vm.jds },
                            on: {
                              "select-jd": function($event) {
                                return _vm.onFrequentJdSelect($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.$user.isAdmin()
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    small: "",
                                    icon: "",
                                    color: "background darken-1",
                                    to: { name: "Maestro search" },
                                    target: "_blank"
                                  }
                                },
                                [_c("v-icon", [_vm._v("search")])],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("LauncherHistory", {
                    attrs: { jds: _vm.jds, jd_selected: _vm.jd_selected },
                    on: {
                      "open-form": function($event) {
                        return _vm.onJdSelected($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-none",
                      attrs: {
                        flat: "",
                        color: "primary",
                        disabled: !_vm.jd_version_selected
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadTemplate()
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("file_download")
                      ]),
                      _vm._v("\n\t\t\t\tTemplate XLSX\n\t\t\t")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-none",
                      attrs: {
                        flat: "",
                        color: "primary",
                        disabled: !_vm.jd_version_selected
                      },
                      on: {
                        click: function($event) {
                          _vm.step = "batch"
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { large: "" } },
                        [_vm._v("playlist_play")]
                      ),
                      _vm._v("\n\t\t\t\tEditer un batch\n\t\t\t")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-none",
                      attrs: {
                        color: "primary color--text",
                        disabled: !_vm.jd_version_selected
                      },
                      on: {
                        click: function($event) {
                          _vm.step = "unitary"
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { large: "" } },
                        [_vm._v("play_arrow")]
                      ),
                      _vm._v("\n\t\t\t\tConfigurer un job\n\t\t\t")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.step === "unitary"
        ? [
            _c("LauncherUnitary", {
              attrs: {
                jd: _vm.jd_version_selected,
                parameters: _vm.parameters,
                param: _vm.param,
                parent_jr_id: _vm.parent_jr_id,
                dialog: _vm.dialog
              },
              on: {
                close: function($event) {
                  return _vm.$emit("close")
                },
                "edit-batch": function($event) {
                  _vm.unitary_to_batch_data = $event
                  _vm.step = "batch"
                },
                "modal-width": function($event) {
                  _vm.modal_width = $event || "1080px"
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "card-title",
                    fn: function() {
                      return [
                        _c("LauncherHeader", {
                          attrs: {
                            step: _vm.step,
                            jd: _vm.jd_version_selected
                          },
                          on: {
                            close: function($event) {
                              return _vm.$emit("close")
                            },
                            search: function($event) {
                              _vm.$emit("remove-dupli-data")
                              _vm.step = "search"
                              _vm.modal_width = "1080px"
                            }
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1080874921
              )
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.step === "batch"
        ? [
            _c("LauncherBatch", {
              attrs: {
                jd: _vm.jd_version_selected,
                jds: _vm.jds,
                last_version_number: _vm.jd_versions[0].version_number,
                unitary_to_batch_data: _vm.unitary_to_batch_data
              },
              on: {
                "unitary-data-loaded": function($event) {
                  _vm.unitary_to_batch_data = null
                },
                "change-jd": function($event) {
                  _vm.jd_selected = $event
                },
                "change-jd-version": function($event) {
                  _vm.jd_version_selected = $event
                },
                "change-jd-versions": function($event) {
                  _vm.jd_versions = $event
                },
                "modal-width": function($event) {
                  _vm.modal_width = $event || "1080px"
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "card-title",
                    fn: function() {
                      return [
                        _c("LauncherHeader", {
                          attrs: {
                            step: _vm.step,
                            jd: _vm.jd_version_selected
                          },
                          on: {
                            close: function($event) {
                              return _vm.$emit("close")
                            },
                            search: function($event) {
                              _vm.step = "search"
                              _vm.modal_width = "1080px"
                            }
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3793137296
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9df4d620", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df4d620","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/launcher_v2.vue
// module id = null
// module chunks = 